<svg-icon class="ui-dialog-close" src="/assets/icons/cross-thing.svg" uiDialogClose></svg-icon>
<h3>{{settings.header}}</h3>
<ui-input>
    <textarea
        uiInput
        name="request"
        [(ngModel)]="request"
        [placeholder]="settings.placeholder"
        cols="20"
        rows="4"
    >
    </textarea>
</ui-input>
<button
    class="default"
    angulartics2On="click"
    angularticsCategory="Feature Request"
    angularticsLabel="visit"
    [angularticsValue]="request"
    [angularticsAction]="settings.requestType"
    [disabled]="!request"
    (click)="onSendRequest()"
>
    Send request
</button>